import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { f as forwardEvent } from './p-rUtJRH95.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { i as isOtherOption } from './p-CD8wTaMP.js';
import { H as HiddenHTMLSelect } from './p-BYoISW3Y.js';
import { d as defineCustomElement$e } from './p-BbTg3Car.js';
import { d as defineCustomElement$d } from './p-CE-SFMeF.js';
import { d as defineCustomElement$c } from './p-bjt-RAeH.js';
import { d as defineCustomElement$b } from './p-BZccBFnt.js';
import { d as defineCustomElement$a } from './p-Da2lAZSv.js';
import { d as defineCustomElement$9 } from './p-DUcqAgyP.js';
import { d as defineCustomElement$8 } from './p-Cx1d0m6y.js';
import { d as defineCustomElement$7 } from './p-C8rNIEim.js';
import { d as defineCustomElement$6 } from './p-BU1hvS3W.js';
import { d as defineCustomElement$5 } from './p-DogHpTtE.js';
import { d as defineCustomElement$4 } from './p-CEvUoLql.js';
import { d as defineCustomElement$3 } from './p-FpOQMZxV.js';
import { d as defineCustomElement$2 } from './p-cR96ip-k.js';
import { d as defineCustomElement$1 } from './p-Bn01tsA6.js';

const checkListInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiCheckListInput = /*@__PURE__*/ proxyCustomElement(class WuiCheckListInput extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Options
         */
        this.options = [];
        /**
         * If disabled
         */
        this.disabled = false;
        this.handleInput = (e, option) => {
            // Stop the inner input event from bubbling up
            e.stopPropagation();
            const val = toValue(option);
            if (typeof val === 'undefined') {
                return;
            }
            if (this.value?.includes(val)) {
                this.value = this.value.filter((v) => v !== val);
            }
            else {
                this.value = [...(this.value ?? []), val];
            }
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
    }
    render() {
        return (h(Host, { key: 'd9cbefa6249a4e11392d9a1472524b812926e2f4' }, h(HiddenHTMLSelect, { key: '48691dfc86e413d884b107c59a3635eb1efa9fb4', disabled: this.disabled, options: this.options, value: this.value, name: this.name, multiple: true }), h("wui-list", { key: '8bf24bf3bfe984871f0521af026529b22e801c93', ...this.list, onFocus: (e) => {
                forwardEvent(e, this.elm);
            }, onBlur: (e) => {
                forwardEvent(e, this.elm);
            } }, this.options?.map((option, idx) => {
            if (isOtherOption(option)) {
                switch (option.type) {
                    case 'header':
                        return h("wui-list-item-header", { key: idx, ...option });
                    case 'divider':
                        return h("wui-list-item-divider", { key: idx });
                    case 'meta':
                        return h("wui-list-item-meta", { key: idx, ...option });
                }
            }
            const isOptionChecked = (this.value || []).includes(`${toValue(option)}`);
            const isOptionDisabled = typeof option === 'object' && option.disabled;
            return (h("wui-list-item", { key: idx, ...(typeof option === 'object' ? option : {}), checkable: true, checked: isOptionChecked, disabled: this.disabled || isOptionDisabled, onInput: (e) => this.handleInput(e, option), label: toLabel(option) }));
        }))));
    }
    get elm() { return this; }
    static get style() { return checkListInputCss; }
}, [257, "wui-check-list-input", {
        "value": [1040],
        "options": [16],
        "name": [1],
        "list": [16],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-check-list-input", "wui-box", "wui-check-input", "wui-divider", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCheckListInput);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiCheckListInput as W, defineCustomElement as d };
